<template>
  <div class="event-card" @click="goTo(routes.ticketSeller.purchase, { eventId: event.id })">
    <div class="card-wrapper">
      <div class="card-content">
        <div class="event-date">
          <div class="event-month">{{ formatDate(dateAndTime, 'MMM') }}</div>
          <div class="event-day">{{ formatDate(dateAndTime, 'DD') }}</div>
        </div>
        <div class="event-content">
          <div class="event-title">{{ title }}</div>
          <div class="event-caption">
            {{ formatDate(dateAndTime, 'MMM') }} {{ formatDate(dateAndTime, 'DD') }},
            {{ formatDate(dateAndTime, 'YYYY') }} at {{ formatDate(dateAndTime, 'HH') }}:{{
              formatDate(dateAndTime, 'mm')
            }}
            @
            {{ location.venue }}
          </div>
          <div class="tickets-data">
            <div class="available-tickets-number" translate="no">{{ availableQuantity }}</div>
            <div class="total-tickets-number" translate="no">/{{ initialQuantity }} available</div>
          </div>
        </div>
      </div>
      <img alt="event-type" :src="imgSrc" class="event-type-img" />
    </div>
    <div v-if="cover" class="event-photo">
      <img :src="cover" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { formatDate } from '@/utils'
import { EventTypeImgSrc, OrganizationType } from '@/types'

export default {
  name: 'event-card',
  props: {
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dateAndTime: moment(this.event.from).locale('en'),
      location: this.event.location,
      availableQuantity: 0,
      initialQuantity: 0,
      EventTypeImgSrc,
      title: this.event.title,
      cover: this.event.cover,
      imgSrc: this.event.extraModules.floorPlan
        ? EventTypeImgSrc.FLOOR_PLAN
        : EventTypeImgSrc.REGULAR,
      formatDate,
    }
  },

  mounted() {
    if (this.event.organization.type === OrganizationType.THEATER) {
      this.initialQuantity = this.event.audienceCapacity
      this.availableQuantity = this.event.numOfRemainingTickets

      return
    }

    for (let orderItem of this.event.orderItems) {
      this.initialQuantity += this.event.extraModules.floorPlan
        ? orderItem.sectionSeats.length
        : parseInt(orderItem.initialQuantity)
      this.availableQuantity += this.event.extraModules.floorPlan
        ? orderItem.sectionSeats.length - parseInt(orderItem.initialQuantity - orderItem.quantity)
        : parseInt(orderItem.quantity)
    }
  },
}
</script>

<style scoped>
.event-card {
  box-shadow: none;
  display: flex;
  background-color: #f5f5f5;
  width: 100%;
  border-radius: 1.5rem;
  justify-content: space-between;
  cursor: pointer;
  font-family: Raleway, 'sans-serif';
  font-feature-settings: 'pnum' on;
  font-feature-settings: 'lnum' on;
}

.event-title {
  color: #0277bd;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.03em;
  padding: 0;
}

.card-content {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.event-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}

.tickets-data {
  display: flex;
  align-items: baseline;
}

.v-card__text {
  padding: 0;
  width: unset;
}

.event-caption {
  color: #333333;
  font-family: 'Source sans pro';
  font-weight: 400;
  line-height: 120%;
  font-size: 0.875rem;
  margin: 0.5rem 0;
}

.available-tickets-number {
  font-size: 2rem;
  line-height: 120%;
  color: #0277bd;
  font-weight: 800;
  letter-spacing: -0.015em;
  font-feature-settings: 'pnum' on, 'lnum' on;
}

.total-tickets-number {
  color: #666666;
  font-size: 1rem;
  line-height: 120%;
  font-weight: 600;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
}

.event-date {
  display: flex;
  flex-direction: column;
  padding: 0.25rem 1rem 0 1rem;
}

.event-month {
  font-weight: 700;
  font-size: 1rem !important;
  text-align: center;
  font-family: Raleway, sans-serif;
  text-transform: uppercase;
  line-height: 120%;
  letter-spacing: -0.015em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}

.event-day {
  font-weight: 600;
  font-size: 1.5rem;
  text-align: center;
  font-family: Raleway, sans-serif;
  line-height: 100%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
}

.event-photo img {
  aspect-ratio: 16/9;
  height: 100%;
  max-width: 213px;
  object-fit: cover;
  border-radius: 0 1.5rem 1.5rem 0;
}

@media (max-width: 576px) {
  .event-card {
    display: flex;
    flex-direction: column-reverse;
    max-height: fit-content;
  }

  .event-content {
    min-height: 100%;
  }

  .event-photo img {
    aspect-ratio: 16/9;
    border-radius: 1.5rem 1.5rem 0 0;
    max-width: 100%;
    max-height: 100%;
  }
}
.card-wrapper {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0.75rem 0.75rem 0;
  width: 100%;
}
.event-type-img {
  height: 25px;
  width: 25px;
}
</style>
